
$(document).ready(function(){
  $('.ProductMain_Images').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
     infinite: false,
  asNavFor: '.ProductThumb_Images',
    arrows: true,
    prevArrow: '<button id="prevArrowTemplate" class="CustomPrevious slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></button>',
    nextArrow: '<button id="nextArrowTemplate" class="Customnext slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></button>',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true
      }
    }
    
  ]
  });
$('.ProductThumb_Images').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  asNavFor: '.ProductMain_Images',
  dots: false,
  rows:0,
  centerMode: false,
  focusOnSelect: true,
   prevArrow: '<button id="prevArrowTemplate" class="CustomPrevious CustomThumb_Previous slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="customtext icon__fallback-text">Previous</span></button>',
    nextArrow: '<button id="nextArrowTemplate" class="Customnext CustomThumb_Next slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class=" customtwo_text icon__fallback-text">Next</span></button>',
   

});

'use strict';

/* global jQuery, PhotoSwipe, PhotoSwipeUI_Default, console */

(function($) {

  // Init empty gallery array
  var container = [];

  // Loop over gallery items and push it to the array
  $('#gallery').find('figure').each(function() {
    var $link = $(this).find('a'),
      item = {
        src: $link.attr('href'),
        w: $link.data('width'),
        h: $link.data('height'),
        title: $link.data('caption')
      };
    container.push(item);
  });

  // Define click event on gallery item
  $('.ProductMain_Images a').click(function(event) {

    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $('.pswp')[0],
      options = {
        index: $(this).parent('figure').index(),
        bgOpacity: 0.85,
        showHideOpacity: true
      };

    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
    gallery.init();
  });

}(jQuery));  

$(document).on('click','.CrossIcon',function(){
$('.pswp__button--close').trigger('click');
    
});
    $(document).on('click','.MediaList_Image',function(){
$('body').addClass('ActivePopup');    
});
$(document).on('click','.CrossIcon',function(){
$('body').removeClass('ActivePopup');    
});

  $('[data-index]').click(function(e) {
   e.preventDefault();
    var slideno = $(this).data('index');
    $('.ProductMain_Images ').slick('slickGoTo', slideno - 1);
 });

  $(document).on('click','.mainleft',function(){
$('.hideletft').trigger('click')   
});

    $(document).on('click','.mainright',function(){
$('.hideright').trigger('click')   
});
})
 